import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useReasonReducer = () => useSelector((state: ApplicationState) => state.reason);
